import { ICourseOption } from '@into-discovery/browsewebshared';
import React from 'react';
import PathwayOptionRow from './pathway-option-row';

type Props = {
  courseOptions: ICourseOption[];
  univPath: string;
  brandId: string;
  brandName: string;
};

export default function PathwayOptions({
  courseOptions,
  univPath,
  brandId,
  brandName,
}: Props) {
  if (!courseOptions?.length) {
    return null;
  }
  const courseOptionList = courseOptions.map((courseOption) => (
    <PathwayOptionRow
      key={`${courseOption.name} ${courseOption.slug}`}
      brandName={brandName}
      courseOption={courseOption}
      originUnivPath={univPath}
      brandId={brandId}
      disableCourseLink={courseOption?.disableCourseLink}
    />
  ));

  return <>{courseOptionList}</>;
}
